import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { LOCAL__ui_set_string } from '@/state/ui/_base/LOCAL__ui_set_string';
import { DTODiffusionModelUDBase } from '@shared/dto/+model/sd/_base/dto_diffusion_model_ud_base';
import { flexRender, Row } from '@tanstack/react-table';

interface Props {
  row: Row<DTODiffusionModelUDBase>;
  style: React.CSSProperties;
  className?: string;
}

export function DiffusionModelsTableRow({ row, style, className = '' }: Props) {
  const dispatch = use_dispatch();

  /*
   * METHODS
   */

  function set_is_row_hovered(value: string) {
    dispatch(LOCAL__ui_set_string({ key: 'page_diffusion_models_table_row_hovered_id', value, valid_values: [value, ''] }));
  }

  /*
   * HTML
   */

  return (
    <div
      style={style}
      onMouseEnter={() => set_is_row_hovered(row.original._id)}
      onMouseLeave={() => set_is_row_hovered('')}
      className={`flex items-center justify-start border-b border-dashed border-component-border ${className}`}
    >
      {row.getVisibleCells().map((cell: any) => (
        <div key={cell.id} style={{ width: cell.column.getSize() }} className="p-2 overflow-hidden truncate whitespace-nowrap">
          {flexRender(cell.column.columnDef.cell, cell.getContext())}
        </div>
      ))}
    </div>
  );
}
